// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
import { ErrorsFragmentDoc, UserManagementFragmentDoc } from './UpdateUserSettingsMutation';
export type TelegramMutationVariables = Exact<{
  telegramData: string;
  domain: string;
  language?: string | null | undefined;
  dateOfBirth?: number | null | undefined;
  email?: string | null | undefined;
  phone?: string | null | undefined;
  username?: string | null | undefined;
  refCode?: string | null | undefined;
  refAff?: string | null | undefined;
  cid?: string | null | undefined;
  offers?: boolean | null | undefined;
  site: string;
  otp?: string | null | undefined;
  friendRef?: string | null | undefined;
}>;


export type TelegramMutation = { userManagementAuthWithTelegram: { token: string | undefined, deviceDataToken: string | undefined, sessionId: string | undefined, userManagement: { id: string, user: { __typename: 'UserManagementUser', id: string, email: string | undefined, username: string | undefined, signupTime: number | undefined, authMethods: Array<string | undefined> | undefined } | undefined, profile: { __typename: 'UserManagementProfile', _id: string | undefined, id: string, firstName: string | undefined, lastName: string | undefined, maidenName: string | undefined, email: string | undefined, country: string | undefined, phone: string | undefined, affiliateID: string | undefined, city: string | undefined, zip: string | undefined, house: string | undefined, address: string | undefined, state: string | undefined, dateOfBirth: number | undefined, language: string | undefined, hasOtp: boolean | undefined, hasSMS2FA: boolean | undefined, emailVerified: boolean | undefined, passwordChangeDate: number | undefined, contactsRequestedTime: number | undefined, lineId: string | undefined, conversionCurrency: string | undefined, telegramId: string | undefined, settings: { siteTheme: string | undefined, wallets: string | undefined, loyaltyLandingDisabled: string | undefined, loyaltyLevelNotfDisabled: string | undefined, verifyEmailClosed: string | undefined, rtpLiveOnboardingClosed: string | undefined, preferredInGameCurrency: string | undefined, inGameCurrencyOnboardingClosed: string | undefined, hasVisitedBCIO: string | undefined } | undefined } | undefined, countryInfo: { __typename: 'UserManagementCountryInfo', id: string, countryCode: string | undefined, blocked: boolean | undefined } | undefined } | undefined, errors: Array<{ message: string | undefined, params: Array<{ name: string | undefined, value: string | undefined } | undefined> | undefined } | undefined> | undefined } | undefined };


export const TelegramMutationDocument = gql`
    mutation TelegramMutation($telegramData: String!, $domain: String!, $language: String, $dateOfBirth: Int, $email: String, $phone: String, $username: String, $refCode: String, $refAff: String, $cid: String, $offers: Boolean, $site: String!, $otp: String, $friendRef: String) {
  userManagementAuthWithTelegram(
    input: {
      site: $site
      domain: $domain
      dateOfBirth: $dateOfBirth
      email: $email
      phone: $phone
      language: $language
      telegramData: $telegramData
      username: $username
      offers: $offers
      refCode: $refCode
      refAff: $refAff
      cid: $cid
      otp: $otp
      friendRef: $friendRef
    }
  ) {
    token
    deviceDataToken
    userManagement {
      ...UserManagementFragment
    }
    errors {
      ...ErrorsFragment
    }
    sessionId
  }
}
    ${UserManagementFragmentDoc}
${ErrorsFragmentDoc}`;